<div class="main_box">
    <div>
        <div>
            <div class="modal-header header-bg">
                <h4 class="modal-title format">Router Information: {{routerData?.assetId || 'N/A'}}</h4>
            </div>
            <div class="grid-container">

                <div class="grid-item">
                    <p class="device_info_heading">Router ID</p>
                    <p class="device_info">{{((routerData?.routerId) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Asset ID</p>
                    <p class="device_info">{{routerData?.assetId || 'N/A'}}</p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">MAC</p>
                    <p class="device_info">{{routerData?.mac || 'N/A'}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">IMEI</p>
                    <p class="device_info">{{routerData?.imei || 'N/A'}}</p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">MEID</p>
                    <p class="device_info">{{routerData?.meId || 'N/A'}}</p>
                </div>

                <div class="grid-item">
                    <p class="device_info_heading">IPV4 Address</p>
                    <p class="device_info">{{routerData?.ipv4Address || 'N/A'}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">IPV6 Address</p>
                    <p class="device_info">{{routerData?.ipv6Address || 'N/A'}}</p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Serial Number</p>
                    <p class="device_info">{{((routerData?.serialNumber) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Description</p>
                    <p class="device_info">{{routerData?.description || 'N/A'}}</p>
                </div>

                <div class="grid-item">
                    <p class="device_info_heading">Current WAN Interface</p>
                    <p class="device_info">{{((routerData?.currentWanInterface) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Current WAN Priority</p>
                    <p class="device_info">{{((routerData?.currentWanPriority) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Previous WAN Interface</p>
                    <p class="device_info">{{((routerData?.previousWanInterface) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Previous WAN Priority</p>
                    <p class="device_info">{{((routerData?.previuosWanpriority) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Enabled</p>
                    <p class="device_info">{{((routerData?.previuosWanpriority) || 'N/A')}} </p>
                </div>

                <div class="grid-item">
                    <p class="device_info_heading">State</p>
                    <p class="device_info">{{((routerData?.state) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">State Update At</p>
                    <p class="device_info">{{((routerData?.stateUpdateAt) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Host Name</p>
                    <p class="device_info">{{((routerData?.hostName) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Group Name</p>
                    <p class="device_info">{{((routerData?.gruopName) || 'N/A')}} </p>
                </div>


                <div class="grid-item">
                    <p class="device_info_heading">Group ID Address</p>
                    <p class="device_info">{{((routerData?.groupIpAddress) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Enabled</p>
                    <p class="device_info">{{((routerData?.enabled) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">LAN Port Off</p>
                    <p class="device_info">{{((routerData?.lanPortOff) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Protocal</p>
                    <p class="device_info">{{((routerData?.protocal) || 'N/A')}} </p>
                </div>

                <div class="grid-item">
                    <p class="device_info_heading">WAN Port Start</p>
                    <p class="device_info">{{((routerData?.wanPortStart) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">WAN Port End</p>
                    <p class="device_info">{{((routerData?.wanPortEnd) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Model</p>
                    <p class="device_info">{{((routerData?.model) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">MFG Model</p>
                    <p class="device_info">{{((routerData?.mfgModel) || 'N/A')}} </p>
                </div>

                <div class="grid-item">
                    <p class="device_info_heading">ICCID</p>
                    <p class="device_info">{{((routerData?.iccid) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">IMSI</p>
                    <p class="device_info">{{((routerData?.imsi) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Bytes In</p>
                    <p class="device_info">{{((routerData?.bytesIn) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">Bytes Out</p>
                    <p class="device_info">{{((routerData?.bytesOut) || 'N/A')}} </p>
                </div>
                <div class="grid-item">
                    <p class="device_info_heading">LTE Bandwidth</p>
                    <p class="device_info">{{((routerData?.ltebandwidth) || 'N/A')}} </p>
                </div>
            </div>
            <div class="modal-header" style="background-color: #294058;">
                <h4 class="modal-title" style="margin: auto;color: white;">Port Forwarding Rules</h4>
            </div>
            <div class="grid-container2">
                <div *ngIf="routerData?.groupDTO?.length > 0; else noDataTemplate">
                    <div *ngFor="let group of routerData?.groupDTO" class="group-table">
                        <h3>{{ group.gruopName }}</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th class="txt-cntr">Enabled</th>
                                    <th class="txt-cntr">Group IP Address</th>
                                    <th class="txt-cntr">LAN Port Off</th>
                                    <th class="txt-cntr">Group Name</th>
                                    <th class="txt-cntr">Protocol</th>
                                    <th class="txt-cntr">WAN Port Start</th>
                                    <th class="txt-cntr">WAN Port End</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="txt-cntr">{{ group.enabled }}</td>
                                    <td class="txt-cntr">{{ group.groupIpAddress }}</td>
                                    <td class="txt-cntr">{{ group.lanPortOff }}</td>
                                    <td class="txt-cntr">{{ group.gruopName }}</td>
                                    <td class="txt-cntr">{{ group.protocal }}</td>
                                    <td class="txt-cntr">{{ group.wanPortStart }}</td>
                                    <td class="txt-cntr">{{ group.wanPortEnd }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <ng-template #noDataTemplate>
                    <p class="no-data">No Data found</p>
                </ng-template>
            </div>
        </div>
    </div>
</div>